import { render, staticRenderFns } from "./recordList.vue?vue&type=template&id=39d7feb9&scoped=true"
import script from "./recordList.vue?vue&type=script&lang=js"
export * from "./recordList.vue?vue&type=script&lang=js"
import style0 from "./recordList.vue?vue&type=style&index=0&id=39d7feb9&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d7feb9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39d7feb9')) {
      api.createRecord('39d7feb9', component.options)
    } else {
      api.reload('39d7feb9', component.options)
    }
    module.hot.accept("./recordList.vue?vue&type=template&id=39d7feb9&scoped=true", function () {
      api.rerender('39d7feb9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/orderBox/afterSale/recordList.vue"
export default component.exports